// extracted by mini-css-extract-plugin
module.exports = {"aboutPage":"ad_aboutPage__3f3Cm","banner":"ad_banner__3ags1","about":"ad_about__HZ9C5","title":"ad_title__1AOsw","contact":"ad_contact__AAA-F","tit":"ad_tit__1Qe8q"};